export default "https://cdn-static.gokick.com/assets/6a734ef49f9399dbf744c5b441c6b52a80c19f9a/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";